import { createRouter, createWebHistory } from 'vue-router';

import LoginPage from '../views/LoginPage.vue';
import PartnerPage from '@/views/partner/PartnerPage.vue';
import DetailPartnerPage from '@/views/partner/DetailPartnerPage.vue';
import DetailEmployeePage from '@/views/partner/DetailEmployeePage.vue';
import BookingPage from '../views/booking/BookingPage.vue';
import BookingDetailsPage from '../views/booking/BookingDetailsPage.vue';
import JourneyDetailsPage from '../views/booking/JourneyDetailsPage.vue';
import BookingRequestDetailPage from '../views/booking/BookingRequestDetailPage.vue';
import AddBookingPage from '../views/booking/AddBookingPage.vue';

import AddPartnerPage from '@/views/partner/AddPartnerPage.vue';
import AddAgencyPage from '@/views/agency/AddAgencyPage.vue';
import AgencyPage from '@/views/agency/AgencyPage.vue';
import DetailAgencyPage from '@/views/agency/DetailAgencyPage.vue';
import ContabilitaPage from '@/views/contabilita/ContabilitaPage.vue';
import Cod1Page from '@/views/contabilita/COD1/Cod1Page.vue';
import Cod2Page from '@/views/contabilita/COD2/Cod2Page.vue';
import Cod3Page from '@/views/contabilita/COD3/Cod3Page.vue';
import Cod4PageBooking from '@/views/contabilita/COD4/Cod4Page.vue';
import Cod4PageValet from '@/views/contabilita/COD4/Cod4ValetPage.vue';
import Cod5Page from '@/views/contabilita/COD5/Cod5Page.vue';
import Cod6DetailPage from '@/views/contabilita/COD6/Cod6DetailPage.vue';
import Cod8Page from '@/views/contabilita/COD8/Cod8Page.vue';
import Cod7Page from '@/views/contabilita/COD7/Cod7Page.vue';
import DriverPage from '@/views/driver/DriverPage';
import DriverDetailPage from '@/views/driver/DriverDetailsPage';
import AddDriverPage from '@/views/driver/AddDriverPage';
import DriverCapacityPage from '@/views/driver/DriverCapacityPage.vue';
import CustomerPage from '@/views/customer/CustomerPage';
import AddCustomerPage from '@/views/customer/AddCustomerPage';
import CustomerDetailPage from '@/views/customer/CustomerDetailPage';
import ResetPassword from '@/views/ResetPasswordPage';
import { isLoggedStore } from '@/store/logged';
import EstimatePageVue from '@/views/booking/EstimatePage.vue';
import SupplierPage from '@/views/supplier/SupplierPage.vue';
import AdvisorPage from '@/views/advisor/AdvisorPage.vue';
import AddJourneyPage from '@/views/journey/AddJourneyPage.vue';
const routes = [
  // La home è la lista Booking di tutte le province: la pagina
  // bianca di benvenuto non serviva a nessuno.
  { path: '/', redirect: '/booking' },
  {
    // Creazione di uno Spostamento Interno. La logica delle corse è quella,
    // invariata, del gestionale partner (vedi composables/useJourneyLegs.js):
    // qui in più si sceglie il partner, che là era l'utente loggato.
    path: '/journey/new',
    name: 'AddJourney',
    component: AddJourneyPage,
  },
  {
    // Fornitori di mezzi per i Transfer: alimentano il COD8.
    path: '/supplier',
    name: 'Supplier',
    component: SupplierPage,
  },
  {
    // Advisor: chi segue i partner, con la provvigione del COD7.
    path: '/advisor',
    name: 'Advisor',
    component: AdvisorPage,
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
  },
  {
    path: '/partner',
    component: PartnerPage,
  },
  {
    path: '/add-partner',
    component: AddPartnerPage,
  },
  {
    path: '/agency',
    component: AgencyPage,
  },
  {
    path: '/add-agency',
    component: AddAgencyPage,
  },
  {
    path: '/agency/:id',
    component: DetailAgencyPage,
  },
  {
    path: '/partner/:id',
    component: DetailPartnerPage,
  },
  {
    path: '/employee/:id',
    component: DetailEmployeePage,
  },
  {
    path: '/booking',
    name: 'Booking',
    component: BookingPage,
  },
  {
    path: '/estimate',
    name: 'Estimate',
    component: EstimatePageVue,
  },
  {
    path: '/contabilita',
    name: 'Contabilita',
    component: ContabilitaPage,
  },
  {
    path: '/contabilita/cod1/:id',
    name: 'Cod1Page',
    component: Cod1Page,
  },
  {
    path: '/contabilita/cod2/:id',
    name: 'Cod2Page',
    component: Cod2Page,
  },
  {
    path: '/contabilita/cod3/:id',
    name: 'Cod3Page',
    component: Cod3Page,
  },
  {
    path: '/contabilita/cod4/:id',
    name: 'Cod4PageBooking',
    component: Cod4PageBooking,
  },

  {
    path: '/contabilita/cod5/:id',
    name: 'Cod5Page',
    component: Cod5Page,
  },
  {
    // COD7: provvigioni advisor. NON confondere con /contabilita/cod7/:id,
    // che è la pagina del pagamento valet.
    path: '/contabilita/cod7',
    name: 'Cod7Advisor',
    component: Cod7Page,
  },
  {
    // COD8: resoconto mensile per fornitore, nessuna entità da scegliere.
    path: '/contabilita/cod8',
    name: 'Cod8',
    component: Cod8Page,
  },
  {
    // COD6 di periodo: niente :id, l'agenzia è un filtro interno.
    path: '/contabilita/cod6',
    name: 'Cod6Periodo',
    component: Cod6DetailPage,
  },
  {
    path: '/contabilita/cod7/:id',
    name: 'Cod4PageValet',
    component: Cod4PageValet,
  },

  {
    path: '/booking/new',
    name: 'AddBooking',
    component: AddBookingPage,
  },
  {
    path: '/booking/detail/:id',
    name: 'BookingDetail',
    component: BookingDetailsPage,
  },
  {
    // Gli spostamenti interni NON sono booking: pagina e tabella diverse.
    path: '/journey/detail/:id',
    name: 'JourneyDetail',
    component: JourneyDetailsPage,
  },
  // ⚠️ Non è un booking: è la richiesta dell'app cliente (booking_request),
  // che diventa una prenotazione solo dopo la conversione.
  {
    path: '/booking/request/:id',
    name: 'BookingRequestDetail',
    component: BookingRequestDetailPage,
  },
  {
    path: '/driver',
    name: 'DriverPage',
    component: DriverPage,
  },
  {
    // Capacità driver per provincia: dato interno di Simba (vedi capacityAPI.js).
    path: '/driver/capacity',
    name: 'DriverCapacityPage',
    component: DriverCapacityPage,
  },
  {
    path: '/driver/detail/:id',
    name: 'DriverDetailPage',
    component: DriverDetailPage,
  },
  {
    path: '/driver/add-driver',
    name: 'AddDriverPage',
    component: AddDriverPage,
  },
  {
    path: '/customer',
    name: 'Customer',
    component: CustomerPage,
  },
  {
    path: '/customer/add-customer',
    name: 'AddCustomer',
    component: AddCustomerPage,
  },
  {
    path: '/customer/detail/:id',
    name: 'CustomerDetail',
    component: CustomerDetailPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const store = isLoggedStore();
  if (
    store.isLogged == false &&
    to.name !== 'Login'
  ) {
    if (to.name !== 'ResetPassword') {
      return { name: 'Login' };
    }
  } 
});

export default router;
